import React, { Fragment } from 'react';
import _ from 'lodash';
import Select from 'react-select';

function noop() {}

class ProductQtySelector extends React.Component {
  constructor(props) {
    super(props);
    this.qtyRange = _.range(0, 10).map(i => {
      return { value: i + 1 };
    });
    this.state = {
      qty: props.defaultQty ? { value: props.defaultQty } : this.qtyRange[0]
    };
  }

  decrease() {
    if (this.state.qty.value > 1)
      this.setState({
        ...this.state,
        qty: { value: this.state.qty.value - 1 }
      });
  }

  increase() {
    this.setState({ ...this.state, qty: { value: this.state.qty.value + 1 } });
  }

  selectQty(item) {
    this.setState({ ...this.state, qty: { ...item } });
  }

  handleClick() {
    this.props.buttonAction(this.state.qty.value);
  }

  render() {
    const { selectorDisabled, buttonDisabled, buttonText } = this.props;

    return (
      <Fragment>
        <div className="visible-sm-block">
          <div className="row">
            <div className="col-xs-3">
              <Select
                instanceId="product-qty"
                className="product-add__select"
                clearable={false}
                searchable={false}
                options={this.qtyRange}
                optionRenderer={item => item.value}
                value={this.state.qty}
                valueRenderer={item => (
                  <span
                    className={
                      selectorDisabled ? 'product-add__select--disabled' : ''
                    }
                  >
                    {item.value}
                  </span>
                )}
                onChange={this.selectQty.bind(this)}
                onSuggestionsFetchRequested={noop}
                onSuggestionsClearRequested={noop}
                disabled={selectorDisabled}
                scrollMenuIntoView={false}
              />
            </div>
            <div className="col-xs">
              <button
                className="btn-primary green btn--full-width product-add__btn"
                onClick={this.handleClick.bind(this)}
                disabled={buttonDisabled}
              >
                {buttonText}
              </button>
            </div>
          </div>
        </div>

        {buttonDisabled ? null : (
          <div className="hidden-sm">
            <MobileAddToCart
              selectorDisabled={selectorDisabled}
              buttonAction={this.handleClick.bind(this)}
              buttonText={buttonText}
              decrease={() => this.decrease()}
              increase={() => this.increase()}
              qty={this.state.qty.value}
            />
          </div>
        )}
      </Fragment>
    );
  }
}

function MobileAddToCart(props) {
  const {
    selectorDisabled,
    buttonAction,
    buttonText,
    decrease,
    increase,
    qty
  } = props;

  return (
    <div className="mini-add-to-cart">
      {selectorDisabled ? (
        <button
          className="btn-primary green mini-add-to-cart__btn mini-add-to-cart__btn--full-width"
          onClick={buttonAction}
        >
          {buttonText}
        </button>
      ) : (
        <Fragment>
          <button className="mini-add-to-cart__decr" onClick={decrease}>
            {' '}
            -{' '}
          </button>
          <div className="mini-add-to-cart__qty">{qty}</div>
          <button className="mini-add-to-cart__incr" onClick={increase}>
            {' '}
            +{' '}
          </button>
          <button
            className="btn-primary green mini-add-to-cart__btn"
            onClick={buttonAction}
          >
            {buttonText}
          </button>
        </Fragment>
      )}
    </div>
  );
}

export default ProductQtySelector;



// WEBPACK FOOTER //
// ./shared/components/product/qtySelector.js